import { monitoringSitesQueryOptions } from '../../../hooks/data/useMonitoringSites'
import { queryClient } from '../../../queryClient'

export async function getMonitoringSites({
  values: samplingAreaIds,
  farmId,
}: {
  values: { id: string; label: string }[]
  farmId: string
}) {
  // Without a farm the request would answer every farm's sites and cache them under the
  // undefined-farm key.
  if (!farmId) return []

  // fetchQuery, not ensureQueryData: a site write invalidates this entry without refetching it
  // when nothing watches it, and ensureQueryData would hand back the invalidated list.
  let monitoringSites = await queryClient.fetchQuery(
    monitoringSitesQueryOptions(farmId, { monitoringOnly: true }),
  )

  if (samplingAreaIds && samplingAreaIds.length) {
    monitoringSites = monitoringSites.filter(site =>
      samplingAreaIds.some(id => id.id === site.samplingAreaId),
    )
  }

  const options = monitoringSites
    .map(site => ({
      id: site.id,
      label: site.name,
      value: site.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return options
}
